export default __webpack_public_path__ + "static/media/invalidation.de9182fc.png";